import { Card, CardContent, Typography, Box, Stack, Chip } from "@mui/material";
import { IHistoricoSituacaoFinanceira } from "../../../../../../../types/api/cadastros/detalhar-cooperado";
import moment from 'moment';

export default function CardHistoricoSituacao({ data }: CardHistoricoSituacaoProps) {

    const historico = data || [];

    if (historico.length === 0) {
        return (
            <Card>
                <CardContent>
                    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                        <Typography variant="h6">
                            Histórico de Situação Financeira
                        </Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary" textAlign="center" py={4}>
                        Nenhum histórico disponível
                    </Typography>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card>
            <CardContent>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                    <Typography variant="h6">
                        Histórico de Situação Financeira
                    </Typography>
                </Stack>

                <Stack spacing={2} sx={{ mt: 2 }}>
                    {historico.map((item, index) => (
                        <Box key={index}>
                            <Stack direction="row" spacing={2}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Box
                                        sx={{
                                            width: 12,
                                            height: 12,
                                            borderRadius: '50%',
                                            bgcolor: 'primary.main',
                                            mt: 0.5
                                        }}
                                    />
                                    {index < historico.length - 1 && (
                                        <Box
                                            sx={{
                                                width: 2,
                                                flexGrow: 1,
                                                bgcolor: 'divider',
                                                my: 0.5,
                                                minHeight: 40
                                            }}
                                        />
                                    )}
                                </Box>

                                <Box sx={{ flexGrow: 1, pb: 2 }}>
                                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                                        {formatarData(item.alterado_em) + ' - ' + item.usuario.nome}
                                    </Typography>

                                    <Stack spacing={1}>
                                        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                            <Chip
                                                size="small"
                                                label={mapearSituacao(item.situacao_nova)}
                                                sx={getStatusChipProps(item.situacao_nova).sx}
                                            />
                                        </Stack>

                                        {item.motivo && (
                                            <Typography variant="body2" color="text.secondary">
                                                <b>Motivo:</b> {item.motivo}
                                            </Typography>
                                        )}
                                    </Stack>
                                </Box>
                            </Stack>
                        </Box>
                    ))}
                </Stack>
            </CardContent>
        </Card>
    );
}

interface CardHistoricoSituacaoProps {
    data: IHistoricoSituacaoFinanceira[];
}

function formatarData(data: string): string {
    return moment(data).format('DD/MM/YYYY [às] HH:mm');
}

function mapearSituacao(codigo: string): string {
    const mapeamento: { [key: string]: string } = {
        'L': 'Liberado',
        'S': 'Sempre Liberado',
        'B': 'Pendências Financeiras',
        'M': 'Bloqueado Manual',
        'D': 'Bloqueado Definitivo'
    };
    return mapeamento[codigo] || codigo;
}

function getStatusChipProps(status: string) {
    let background = "#E0E0E0";
    let textColor = "#444";
    
    if (status === "B") {
        background = "#FFD600";
        textColor = "#444";
    } else if (status === "M" || status === "D") {
        background = "#D32F2F";
        textColor = "#fff";
    } else if (status === "L" || status === "S") {
        background = "#2E7D32";
        textColor = "#fff";
    }

    return {
        sx: {
            background,
            color: textColor,
        }
    };
}

